<template>
  <div id="page">
    <div class="cut">
      <div class="cropper_background" v-if="verticalVersion_tupian"></div>
      <div
        class="cropper_background_horizontal"
        v-if="horizontalVersion_tupian"
      ></div>
      <vue-cropper
        ref="cropper"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="option.info"
        :full="option.full"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :fixed-box="option.fixedBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :center-box="option.centerBox"
        :canScale="option.canScale"
        :enlarge="option.enlarge"
        @real-time="realTime"
        :high="option.high"
        @img-load="imgLoad"
        mode="100%"
        :maxImgSize="option.max"
        style="background-image: none;"
      >
      </vue-cropper>

      <!-- 竖版 -->
      <div class="cropper_icon_log" v-if="verticalVersion">
        <img src="../../../static/hunanDIY/银行log.png" />
      </div>
      <div class="cropper_icon_card" v-if="verticalVersion">
        <img src="../../../static/hunanDIY/银联图标.png" />
      </div>
      <!-- 横版 -->
      <div class="cropper_icon_log_horizontal" v-if="horizontalVersion">
        <img src="../../../static/hunanDIY/银行log.png" />
      </div>
      <div class="cropper_icon_xinpian_horizontal" v-if="horizontalVersion">
        <img src="../../../static/hunanDIY/芯片.png" />
      </div>
      <div class="cropper_icon_yinlian_horizontal" v-if="horizontalVersion">
        <img src="../../../static/hunanDIY/银联.png" />
      </div>
    </div>
    <!-- 选择版式/选择图片 -->
    <div class="foot" v-if="ifSelectFormat">
      <div class="foot_button">
        <div class="foot_button_item" @click="SelectFormat()">
          <img src="../../../static/hunanDIY/选择版式.png" />
          <label>选择版式</label>
        </div>
        <div class="foot_button_item" @click="selectCardface()">
          <img src="../../../static/hunanDIY/选择图片.png" />
          <label>上传照片</label>
        </div>
      </div>
      <div>
        <b-button
          @click="applyNow()"
          variant="danger"
          style="width: 290px; height: 46px;border-radius: 10px;"
          >立即申请</b-button
        >
      </div>
    </div>
    <!-- 横版/竖版 -->
    <div class="foot" v-if="ifHorizontalOrVertical">
      <div class="foot_button">
        <div class="foot_button_item" @click="_vertical()">
          <img src="../../../static/hunanDIY/竖版.png" v-if="shuban" />
          <img src="../../../static/hunanDIY/竖版（1）.png" v-if="shuban1" />
          <label>竖版</label>
        </div>
        <div class="foot_button_item" @click="_horizontal()">
          <img src="../../../static/hunanDIY/横版.png" v-if="hengban" />
          <img src="../../../static/hunanDIY/横版（1）.png" v-if="hengban1" />
          <label>横版</label>
        </div>
      </div>
      <div>
        <b-button
          variant="danger"
          @click="okVersion()"
          style="width: 290px; height: 46px;border-radius: 10px;"
          >确定</b-button
        >
      </div>
    </div>
    <!-- 缩放/旋转 -->
    <div class="foot" v-if="ifRotate">
      <div class="foot_button">
        <div class="foot_button_item" @click="changeScale(1)">
          <img src="../../../static/hunanDIY/双指缩放.png" />
          <label>双指缩放</label>
        </div>
        <div class="foot_button_item" @click="rotateLeft()">
          <img src="../../../static/hunanDIY/左旋.png" />
          <label>点击左旋</label>
        </div>
      </div>
      <div>
        <b-button
          variant="danger"
          @click="completeOperation()"
          style="width: 290px; height: 46px;border-radius: 10px;"
          >确定</b-button
        >
      </div>
    </div>
    <div v-show="false">
      <form ref="imgUploadForm">
        <input
          ref="uploadInput"
          type="file"
          accept="image/*"
          @change.prevent.stop="upload"
        />
      </form>
    </div>
    <b-modal
      ok-only
      ref="model_image"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">您还未上传照片，请上传照片后继续</p>
    </b-modal>
    <!-- 截图白边提示 -->
    <b-modal ok-only ref="model_tip" title="提示" ok-title="确定">
      <p class="my-4">截图框内不能留有空白，请放大或缩小图片</p>
    </b-modal>
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <!-- 截图像素提示 -->
    <b-modal
      ok-only
      ref="model_error_hunan"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
  </div>
</template>

<script>
import "cropperjs/dist/cropper.css";
import config from "../../common/config";
export default {
  name: "ApplyForCard",
  data() {
    return {
      ifSelectFormat: true, //选择版式、选择图片
      ifHorizontalOrVertical: false, //横竖版
      ifRotate: false, //放大缩小旋转
      verticalVersion: true, //竖版
      horizontalVersion: false, //横版
      operationPicture: 0, //操作图片
      imgPath: "",
      bankSerialNumber: "",
      bankCode: "",
      selectParam: null,
      cardOri: "",
      cardTheme: "99",
      option: {
        img: "",
        size: 1,
        info: false,
        full: true,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 214,
        autoCropHeight: 340,
        centerBox: false,
        high: true,
        max: 2000,
        fixed: true,
        fixedNumber: [9, 14],
        canScale: true,
        enlarge: 1
      },
      initScale: "",
      errorMsg: "",
      targetImg: "",
      targetImg_logo: "",
      //-------------------------
      shuban: true,
      shuban1: false,
      hengban: true,
      hengban1: false,
      modifyPicture: "", //是否为修改图片（1：申请，2：修改）
      verticalVersion_tupian: true,
      horizontalVersion_tupian: false,
      imgSizeLimit: 10 * 1024 * 1024, //上传图片大小
      imgWlimit: 1075,
      imgHlimit: 686
    };
  },

  methods: {
    // 选择版式
    SelectFormat() {
      this.ifSelectFormat = false;
      this.ifHorizontalOrVertical = true;
    },
    // 完成操作
    completeOperation() {
      var that = this;
      // 判断是否存在白边
      let has = that.hasWhiteSpace();
      if (!has) {
        that.showCropTip();
        return;
      } else if (has) {
        this.ifSelectFormat = true;
        this.ifHorizontalOrVertical = false;
        this.ifRotate = false;
      }
    },
    // 立即申请
    applyNow() {
      if (this.option.img == "") {
        this.showImage();
      } else {
        this.cropImage();
      }
    },
    // 截图框回正
    updateIcon() {
      this.option.autoCropWidth = 214;
      this.option.autoCropHeight = 340;
      this.option.fixedNumber = [9, 14];
      this.verticalVersion = true;
    },
    // 截图框信息
    realTime(data) {
      console.log("realTime");
      let w = this.$refs.cropper.cropW;
      let h = this.$refs.cropper.cropH;
      // 图片缩放比例
      let scale = this.$refs.cropper.scale;
      // 图片偏移x轴
      let x = this.$refs.cropper.x;
      // 图片偏移y轴
      let y = this.$refs.cropper.y;
      // 图片真实宽度
      let trueWidth = this.$refs.cropper.trueWidth;
      // 图片真实高度
      let trueHeight = this.$refs.cropper.trueHeight;
      // 裁剪框的坐标轴
      let cropX = this.$refs.cropper.cropX;
      let cropY = this.$refs.cropper.cropY;
      console.log("截图框宽高：" + w + "*" + h);
      console.log("图片缩放比例：" + scale);
      console.log("图片偏移x轴：" + x);
      console.log("图片偏移y轴：" + y);
      console.log("图片真实宽度：" + trueWidth);
      console.log("图片真实高度：" + trueHeight);
      console.log("裁剪框的坐标轴：" + cropX + "*" + cropY);
      console.log(data);
    },
    // 截图信息
    imgLoad(msg) {
      console.log(msg);
      // 图片初始缩放比例
      let scale = this.$refs.cropper.scale;
      this.initScale = scale;
      let cropperObj = this.$refs.cropper;
      let maxWidth = cropperObj.w;
      let maxHeight = cropperObj.h;
      let imgW = cropperObj.trueWidth * cropperObj.scale;
      let imgH = cropperObj.trueHeight * cropperObj.scale;
      maxWidth = imgW < maxWidth ? imgW : maxWidth;
      maxHeight = imgH < maxHeight ? imgH : maxHeight;
      console.log("maxWidth:" + maxWidth);
      console.log("maxHeight:" + maxHeight);
      console.log("imgW:" + imgW);
      console.log("imgH:" + imgH);
      console.log("maxWidth:" + maxWidth);
      console.log("maxWidth:" + maxWidth);
      console.log("initScale:" + this.initScale);
    },
    hasWhiteSpace: function() {
      let has = true;
      let axis = this.$refs.cropper.getImgAxis();
      let cropAxis = this.$refs.cropper.getCropAxis();

      console.log(axis);
      console.log(cropAxis);

      // 左边的横坐标 图片不能超过截图框
      if (axis.x1 >= cropAxis.x1) {
        has = false;
      }
      // 右边横坐标
      if (axis.x2 <= cropAxis.x2) {
        has = false;
      }
      // 纵坐标上面
      if (axis.y1 >= cropAxis.y1) {
        has = false;
      }
      // 纵坐标下面
      if (axis.y2 <= cropAxis.y2) {
        has = false;
      }
      return has;
    },
    cropImage: function() {
      var that = this;
      // 判断是否存在白边
      let has = that.hasWhiteSpace();
      if (!has) {
        that.showCropTip();
        return;
      }

      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob(data => {
        console.log(data);
        let url = window.URL.createObjectURL(data);
        // 处理一下图片大小

        console.log("blob url:" + url);
        var base64 = "";
        var base64_logo = "";
        let image = new Image();
        image.src = url;
        let w, h;
        // image.width = that.option.autoCropWidth;
        // image.height = that.option.autoCropHeight;
        image.onload = function() {
          image.onload = null; // 避免重复加载
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          base64 = that.image2Base64(image);
          base64_logo = that.imageTosmall(image);
          console.log("图片宽高:" + image.width + "*" + image.height);
          that.targetImg = base64;
          that.targetImg_logo = base64_logo;
          console.log("图片--->", that.targetImg);
          console.log("图片logo--->", that.targetImg_logo);
          if (that.option.autoCropWidth == 340) {
            //横版
            if (w >= 1024 && h >= 665) {
              that.toCardPreview();
            } else {
              that.errorMsg =
                "剪裁后的图片像素不符合要求，图片像素要求：" + 1024 + "*" + 665;
              that.showErrorMsg();
            }
          } else if (that.option.autoCropHeight == 340) {
            //竖版
            if (w >= 665 && h >= 1024) {
              that.toCardPreview();
            } else {
              that.errorMsg =
                "剪裁后的图片像素不符合要求，图片像素要求：" + 665 + "*" + 1024;
              that.showErrorMsg();
            }
          }
        };
      });
    },
    //图片等比例缩放
    imageTosmall(img) {
      if (this.option.autoCropWidth == 340) {
        var canvas = document.createElement("canvas");
        canvas.width = 340;
        canvas.height = 214;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, 340, 214);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL;
      } else {
        var canvas = document.createElement("canvas");
        canvas.width = 214;
        canvas.height = 340;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, 214, 340);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL;
      }
    },
    //图片转为base64编码
    image2Base64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/png");
      return dataURL;
    },
    // 跳转到信息确认页面
    toCardPreview() {
      let that = this;
      if (this.option.autoCropWidth == 214) {
        this.$router.replace({
          name: "CardPreview",
          params: {
            targetImg_logo: that.targetImg_logo,
            targetImg: this.targetImg,
            hengPath: false,
            shuPath: true,
            bankSerialNumber: this.bankSerialNumber,
            modifyPicture: this.modifyPicture
          }
        });
      } else {
        this.$router.replace({
          name: "CardPreview",
          params: {
            targetImg_logo: that.targetImg_logo,
            targetImg: that.targetImg,
            hengPath: true,
            shuPath: false,
            bankSerialNumber: this.bankSerialNumber,
            modifyPicture: this.modifyPicture
          }
        });
      }
      this.updateIcon();
    },
    refreshCrop() {
      // clear
      this.$refs.cropper.refresh();
    },
    // 放大/缩小
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 左旋
    rotateLeft() {
      this.$refs.cropper.rotateLeft();

      // //旋转100度
      // this.$refs.cropper.rotate = this.$refs.cropper.rotate + 100 / 90;
      // //每次递增旋转9度
      // this.$refs.cropper.rotate = this.$refs.cropper.rotate + 9 / 90;
    },
    // 右旋
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 上传图片
    selectCardface: function() {
      this.resetUpload();
      this.$refs.uploadInput.click();
    },
    resetUpload: function() {
      var form = this.$refs.imgUploadForm;
      console.log(form);
      form.reset();
    },
    upload: function(event) {
      var that = this;
      console.log(event);
      let file = event.target.files[0];
      let fileSize = file.size;
      console.log(file);
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }
      console.log(url);
      // 判断图片大小
      if (fileSize > this.imgSizeLimit) {
        that.errorMsg = "图片大小不能超过10MB";
        that.showErrorMsg_hunan();
        that.resetUpload();
      } else {
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function() {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载

          console.log("图片宽高:" + w + "*" + h);
          console.log("图片大小:" + fileSize / 1024 + "KB");
          if (w >= that.imgWlimit && h >= that.imgHlimit) {
            that.ifRotate = true;
            that.ifSelectFormat = false;
            that.toEditCardface(url);
          } else {
            that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h;
            that.showErrorMsg_hunan();
            that.resetUpload();
          }
        };
      }
    },
    showErrorMsg_hunan() {
      this.$refs["model_error_hunan"].show();
    },
    checkImg: function(imgPath) {
      let that = this;
      wx.getLocalImgData({
        localId: imgPath, // 图片的localID
        success: function(res) {
          var localData = res.localData;
          if (localData.indexOf("data:image") != 0) {
            // 判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          // 第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
          // 这不知道时什么格式的图片，为了兼容其他设备就把它转为jpeg
          let image = new Image();
          let w, h;
          image.src = localData;
          // 如果有缓存，读缓存
          // if (image.complete) {
          //   w = image.width; // 图片宽度
          //   h = image.height; // 图片高度
          // } else { //否则加载图片
          // }
          image.onload = function() {
            w = image.width; // 图片宽度
            h = image.height; // 图片高度
            image.onload = null; // 避免重复加载
            that.toEditCardface(imgPath);
          };
        }
      });
    },
    getImgSize: function(imgBase64) {
      // 1.需要计算文件流大小，首先把头部的data:image/png;base64,（注意有逗号）去掉。
      var str = imgBase64.split(",")[1];
      // 2.找到等号，把等号也去掉
      var equalIndex = str.indexOf("=");
      if (str.indexOf("=") > 0) {
        str = str.substring(0, equalIndex);
      }
      // 3.原来的字符流大小，单位为字节
      var strLength = str.length;
      // 4.计算后得到的文件流大小，单位为字节
      var fileLength = parseInt(strLength - (strLength / 8) * 2);
      return fileLength;
    },
    toEditCardface: function(imgPath) {
      this.option.img = imgPath;
      if (this.option.img == "") {
      } else {
        this.verticalVersion_tupian = false;
        this.horizontalVersion_tupian = false;
      }
      this.operationPicture = 1;
    },
    showImage: function() {
      this.$refs["model_image"].show();
    },
    showErrorMsg: function() {
      this.$refs["model_error"].show();
    },
    handleOk: function(bvModalEvt) {},
    showCropTip: function() {
      this.$refs["model_tip"].show();
    },
    // 竖版
    _vertical() {
      this.option.autoCropWidth = 214;
      this.option.autoCropHeight = 340;
      this.option.fixedNumber = [9, 14];
      this.verticalVersion = true;
      this.horizontalVersion = false;
      this.shuban = true;
      this.shuban1 = false;
      this.hengban = true;
      this.hengban1 = false;
      if (this.option.img == "") {
        this.verticalVersion_tupian = true;
        this.horizontalVersion_tupian = false;
      } else {
        this.verticalVersion_tupian = false;
        this.horizontalVersion_tupian = false;
      }
    },
    // 横版
    _horizontal() {
      this.option.autoCropWidth = 340;
      this.option.autoCropHeight = 214;
      this.option.fixedNumber = [14, 9];
      this.verticalVersion = false;
      this.horizontalVersion = true;
      this.shuban = false;
      this.shuban1 = true;
      this.hengban = false;
      this.hengban1 = true;
      if (this.option.img == "") {
        this.verticalVersion_tupian = false;
        this.horizontalVersion_tupian = true;
      } else {
        this.verticalVersion_tupian = false;
        this.horizontalVersion_tupian = false;
      }
    },
    okVersion() {
      this.ifSelectFormat = true;
      this.ifHorizontalOrVertical = false;
      this.ifRotate = false;
      this.shuban = true;
      this.shuban1 = false;
      this.hengban = true;
      this.hengban1 = false;
    }
  },
  watch: {
    operationPicture: function(newval, oldval) {
      if (newval == 0) {
      } else if (newval == 1) {
        this.ifSelectFormat = false;
        this.ifHorizontalOrVertical = false;
        this.ifRotate = true;
      }
    }
  },
  mounted: function() {
    this.bankSerialNumber = this.$route.params.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    this.modifyPicture = this.$route.params.modifyPicture;
    console.log("bankSerialNumber:" + this.modifyPicture);
  }
};
</script>

<style scoped>
.page {
  background-color: #5d5d5d;
}
.cut {
  width: 100%;
  height: 462px;
  background-color: #5d5d5d;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cropper_background {
  position: absolute;
  background-color: #242424;
  width: 214px;
  height: 340px;
  border-radius: 10px;
  top: 10.3%;
}
.cropper_background_horizontal {
  position: absolute;
  background-color: #242424;
  /* background-color:pink; */
  width: 340px;
  height: 214px;
  border-radius: 10px;
}
.cropper_icon_log {
  position: absolute;
  left: 28%;
  top: 12.29%;
}
.cropper_icon_card {
  position: absolute;
  left: 42.98%;
  top: 38.58%;
}
.cropper_icon_log_horizontal {
  position: absolute;
  left: 12%;
  top: 19.94%;
}
.cropper_icon_xinpian_horizontal {
  position: absolute;
  left: 14.93%;
  top: 29.69%;
}
.cropper_icon_yinlian_horizontal {
  position: absolute;
  left: 71.47%;
  top: 32.68%;
}
.foot {
  background-color: white;
  width: 100%;
  height: 243px;
  border-radius: 20px 20px 0 0;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.foot_button {
  width: 231px;
  height: 102px;
  display: flex;
  /* background-color: pink; */
  justify-content: space-between;
  margin-bottom: 37px;
}

.foot_button_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background-color:yellow; */
}
</style>



// WEBPACK FOOTER //
// src/components/hunanbank/ApplyForCard.vue